import Header from '../../blocks/Header'

interface Search {
    selector: Element | null,
    selectorActiveClass: string
    registerEvents(): void
    render(): void
}

class Search extends Header {
    selector: Element | null
    selectorActiveClass: string

    constructor(selector: string) {
        super()
        this.selector = document.querySelector(`.${selector}`)
        this.selectorActiveClass = 'headerSearch__dropdown'
        this.registerEvents()
    }

    registerEvents(): void {
        const dropdown = document.querySelector(`.${this.selectorActiveClass}`)
        if (dropdown && this.selector) {
            this.selector.addEventListener('click', () => {
                this.toggle(dropdown)
            })
        }

    }

    toggle(dropdown: Element) {
        if (this.selector) {
            this.selector.classList.toggle('active')
            this.toggleHeader(false, this.selector.classList.contains('active'))
        }

        dropdown.classList.toggle(`${this.selectorActiveClass}--active`)
    }

}

export default Search